module.exports = __webpack_public_path__ + "static/4-61ef22395e097a8672630c71713ad568.pdf";